// extracted by mini-css-extract-plugin
module.exports = {"image":"WelcomeText_image__3jK__","welcome-text":"WelcomeText_welcome-text__sb8oj","text":"WelcomeText_text__dfsV9"};